module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('b-card', {
    staticClass: "mainCardBG"
  }, [_c('b-card-text', [_c('b-navbar', {
    staticClass: "formCard",
    staticStyle: {
      "border-radius": "5px !important",
      "padding-left": "0px",
      "height": "auto !important"
    },
    attrs: {
      "toggleable": "lg",
      "type": "dark",
      "variant": "primary"
    }
  }, [_c('b-navbar-nav', [_c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "light"
    },
    on: {
      "click": _vm.previousSalesView
    }
  }, [_c('md-icon', {
    attrs: {
      "icon": "gear-fill",
      "aria-hidden": "true"
    }
  }, [_vm._v("skip_previous")]), _vm._v("Back\n                    ")], 1)], 1), _vm._v(" "), _c('b-navbar-brand', {
    attrs: {
      "center": ""
    }
  }, [_vm._v("Charges Details")]), _vm._v(" "), _c('b-button', {
    staticClass: "ml-3",
    attrs: {
      "disabled": _vm.ExcelBtnName != 'Export as Excel' ? true : false,
      "size": "sm",
      "variant": "outline-info"
    },
    on: {
      "click": function($event) {
        _vm.getReportsReverse('CHARGES_LIST_EXCEL', 'Export as Excel')
      }
    }
  }, [_vm._v(_vm._s(_vm.ExcelBtnName) + "\n                    "), (_vm.ExcelBtnName != 'Export as Excel') ? _c('b-spinner', {
    attrs: {
      "small": "",
      "label": "Small Spinner"
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('b-card', {
    staticClass: "formCard"
  }, [_c('b-card-text', [(_vm.addEditCard) ? _c('b-card', {
    staticClass: "gutr"
  }, [_c('b-row', {
    staticClass: "align-items-end"
  }, [_c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('h5', [_vm._v(" Charges Details")])]), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("\n                                    Charges Name\n                                    "), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "chargesName",
      "name": "chargesName",
      "placeholder": "Charge Name"
    },
    model: {
      value: (_vm.ChargesMaster.chargesName),
      callback: function($$v) {
        _vm.$set(_vm.ChargesMaster, "chargesName", $$v)
      },
      expression: "ChargesMaster.chargesName"
    }
  }), _vm._v(" "), (!_vm.ChargesMaster.chargesName) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n                                    " + _vm._s(_vm.errorList.chargesName) + "\n                                ")]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("\n                                    Charges Code\n                                    "), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "chargesCode",
      "name": "chargesCode",
      "placeholder": "Charge Code"
    },
    model: {
      value: (_vm.ChargesMaster.chargesCode),
      callback: function($$v) {
        _vm.$set(_vm.ChargesMaster, "chargesCode", $$v)
      },
      expression: "ChargesMaster.chargesCode"
    }
  }), _vm._v(" "), (!_vm.ChargesMaster.chargesCode) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n                                    " + _vm._s(_vm.errorList.chargesCode) + "\n                                ")]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Status :")]), _vm._v(" "), _c('md-switch', {
    staticClass: "md-primary",
    attrs: {
      "id": 'approval' + _vm.chargesMaster.isChargesActive,
      "name": "approval",
      "value": _vm.ChargesMaster.isChargesActive == 1 ? true : false
    },
    on: {
      "change": function($event) {
        _vm.activatechargesMaster()
      }
    }
  }, [_c('h6', [_c('b-badge', {
    attrs: {
      "variant": _vm.ChargesMaster.isChargesActive == 1 ? 'success' : 'danger'
    }
  }, [_vm._v(_vm._s(_vm.ChargesMaster.isChargesActive == 1 ? "Active" : "In-Active"))])], 1)])], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('label', [_vm._v("\n                                    Charges Description\n                                    "), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('b-form-textarea', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "chargesDescription",
      "name": "chargesDescription"
    },
    model: {
      value: (_vm.ChargesMaster.chargesDescription),
      callback: function($$v) {
        _vm.$set(_vm.ChargesMaster, "chargesDescription", $$v)
      },
      expression: "ChargesMaster.chargesDescription"
    }
  }), _vm._v(" "), (!_vm.ChargesMaster.chargesDescription) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n                                    " + _vm._s(_vm.errorList.chargesDescription) + "\n                                ")]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('center', [_c('b-button', {
    staticClass: "mt-2",
    staticStyle: {
      "margin-bottom": "0.3rem"
    },
    attrs: {
      "variant": "success",
      "id": "addButtonLoader"
    },
    on: {
      "click": _vm.addchargesMaster
    }
  }, [_vm._v("\n                                        " + _vm._s(_vm.ChargesMaster.idmasterChargers ? "Update" : "Save") + "\n                                    ")])], 1), _vm._v(" "), _c('md-spinner', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "md-indeterminate": "",
      "id": "loader"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "mt-3"
  }, [_c('b-row', [_c('b-col', {
    staticClass: "my-1",
    attrs: {
      "md": "10"
    }
  }, [_c('b-form-group', [_c('b-input-group', [_c('b-form-input', {
    ref: "search",
    attrs: {
      "formatter": _vm.capitalizeAll,
      "placeholder": "Type to Search Charges Master and Code"
    },
    on: {
      "input": _vm.debounceSearch
    },
    model: {
      value: (_vm.filter),
      callback: function($$v) {
        _vm.filter = $$v
      },
      expression: "filter"
    }
  }), _vm._v(" "), _c('b-input-group-append', [_c('b-button', {
    attrs: {
      "disabled": !_vm.filter
    },
    on: {
      "click": _vm.filterClear
    }
  }, [_vm._v("Clear")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('b-button', {
    attrs: {
      "variant": "outline-primary",
      "size": "sm"
    },
    on: {
      "click": function($event) {
        _vm.addEditCardFunc()
      }
    }
  }, [_vm._v("Add")]), _vm._v(" "), _c('h5', {
    staticClass: "text-muted pull-right mt-2 ml-3"
  }, [(_vm.isLoading == false) ? _c('small', [_vm._v(_vm._s(_vm.totalRows) + " Entries")]) : _vm._e()])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "mt-3"
  }, [_c('div', {
    staticClass: "table-responsive tableMain"
  }, [_c('b-table', {
    staticClass: "position-relative",
    attrs: {
      "show-empty": "",
      "stacked": "md",
      "items": _vm.All_Charges_List_data,
      "responsive": "",
      "fields": _vm.Columns,
      "primary-key": "common_over_id",
      "per-page": _vm.perPage,
      "current-page": _vm.currentPage,
      "filter": _vm.filter,
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "sort-direction": _vm.sortDirection
    },
    on: {
      "update:sortBy": function($event) {
        _vm.sortBy = $event
      },
      "update:sortDesc": function($event) {
        _vm.sortDesc = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "idmasterChargers",
      fn: function(row0) {
        return [_c('span', [_vm._v("\n                                        " + _vm._s(row0.index + 1 + (_vm.currentPage - 1) * _vm.perPage) + "\n                                    ")])]
      }
    }, {
      key: "chargesName",
      fn: function(row1) {
        return [_c('span', [_vm._v(_vm._s((row1.item.chargesName != '') ? row1.item.chargesName : '--'))])]
      }
    }, {
      key: "chargesCode",
      fn: function(row11) {
        return [_c('span', [_vm._v(_vm._s((row11.item.chargesCode != '') ? row11.item.chargesCode : '--'))])]
      }
    }, {
      key: "chargesDescription",
      fn: function(row12) {
        return [_c('span', [_vm._v(_vm._s((row12.item.chargesDescription != '') ? row12.item.chargesDescription : '--'))])]
      }
    }, {
      key: "isChargesActive",
      fn: function(row22) {
        return [(_vm.adminToggle == 'Admin') ? _c('div', {
          attrs: {
            "id": 'row' + row22.item.idmasterChargers
          }
        }, [_c('md-switch', {
          staticClass: "md-primary",
          attrs: {
            "id": 'approval' + row22.item.idmasterChargers,
            "name": "approval",
            "value": row22.item.isChargesActive == 1 ? true : false
          },
          on: {
            "change": function($event) {
              _vm.activateChargesUser(row22.item)
            }
          }
        }, [_c('h6', [_c('br'), _vm._v(" "), _c('b-badge', {
          staticStyle: {
            "margin-left": "-45px"
          }
        }, [_vm._v(_vm._s(row22.item.isChargesActive == 1 ? 'Active' : 'In-Active'))])], 1)])], 1) : _c('div', {
          attrs: {
            "id": 'row' + row22.item.idmasterChargers
          }
        }, [_c('h6', [_c('b-badge', [_vm._v(_vm._s(row22.item.isChargesActive == 1 ? 'Active' : 'In-Active'))])], 1)])]
      }
    }, {
      key: "action",
      fn: function(row2) {
        return [_c('b-button', {
          attrs: {
            "variant": "outline-primary",
            "id": "addButtonLoader",
            "size": "sm"
          },
          on: {
            "click": function($event) {
              _vm.editchargesMaster(row2.item)
            }
          }
        }, [_vm._v("Update")])]
      }
    }, {
      key: "companyName",
      fn: function(row14) {
        return [_c('span', [_vm._v("\n                                        Company Name : " + _vm._s(row14.item.companyName) + "\n                                        "), _c('br')]), _vm._v(" "), _c('span', [_vm._v("\n                                        Address : " + _vm._s(row14.item.address) + "\n                                        "), _c('br')])]
      }
    }])
  })], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    staticClass: "my-1",
    attrs: {
      "md": "12"
    }
  }, [_c('b-pagination', {
    staticClass: "my-0 pull-right",
    attrs: {
      "limit": "5",
      "total-rows": _vm.totalRows,
      "per-page": _vm.perPage
    },
    model: {
      value: (_vm.currentPage),
      callback: function($$v) {
        _vm.currentPage = $$v
      },
      expression: "currentPage"
    }
  })], 1)], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('md-dialog-alert', {
    ref: "addPop",
    attrs: {
      "md-content": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e4e235ce","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/masters/chargesMaster.vue
// module id = 2893
// module chunks = 0